import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import {
  isSystemSuperAdminFromToken,
  ProfileService,
  StorageService,
} from '@app-utils';

/** Resolves `/` when no child route is active (org picker or admin home). */
export const landingGuard: CanActivateFn = () => {
  const router = inject(Router);
  const profileSvc = inject(ProfileService);
  const storage = inject(StorageService);

  if (isSystemSuperAdminFromToken(storage)) {
    return router.parseUrl('/admin/setting/organisations');
  }

  const orgList = profileSvc.latestOrganizationList();
  if (orgList.length === 1) {
    return router.createUrlTree(['/org', orgList[0].id]);
  }

  const selected = profileSvc.latestOrganization();
  if (selected?.id) {
    return router.createUrlTree(['/org', selected.id]);
  }

  return true;
};
